import React, { useState } from "react";
import styled from "@emotion/styled";

import { ColorWithSize, Condition } from "@pages/register/_components/index";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import useRegisterStepStore from "@store/register/useRegisterStepStore";
import useSelectedColorStore from "@store/register/useSelectedColor";
import { useTranslation } from "react-i18next";
import FadeInContainer from "@components/motion/FadeInContainer";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
});

const Title = styled.h3(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "2rem",
  lineHeight: "2.8rem",
  fontWeight: theme.fontWeight.bold,
}));

const RegisterProductStepTwo = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();
  const { increaseStep } = useRegisterStepStore();

  const stockList = watch("stock_list");
  const productCondition = watch("product_condition");
  const [showSizeError, setShowSizeError] = useState(false);

  // const hasSizeError = stockList?.some((stock: any) =>
  //   stock.size_list.some((size: any) => !size.size_id || size.amount < 1),
  // );

  const valid = async () => {
    setShowSizeError(false); // 버튼 클릭 시 먼저 초기화

    // 유효하지 않은 데이터가 하나라도 있으면 true 반환
    const hasInvalidData = stockList.some(
      (stock: any) =>
        // 색상 정보 누락
        !stock.color_id ||
        // 사이즈 정보 누락
        !stock.size_list?.length ||
        // 사이즈의 필수값 누락
        stock.size_list.some((size: any) => !size.size_id || !size.amount),
    );

    if (hasInvalidData) {
      setShowSizeError(true); // 오류 발생 시 메시지 표시
      return;
    }

    // 유효하지 않은 데이터가 없을 때만 다음 스텝
    if (!hasInvalidData) {
      increaseStep();
    }
  };

  return (
    <Container>
      <Title>
        <span>{t("등록하려는 상품의")}</span>
        <span>{t("상세정보를 알려주세요.")}</span>
      </Title>

      <ColorWithSize showSizeError={showSizeError} />

      <Condition />
      <FadeInContainer isShow={!!productCondition}>
        <BasicButton
          title="다음"
          height="5.2rem"
          width="100%"
          padding="1.6rem 1.2rem"
          disabled={!stockList?.length || !productCondition}
          onClick={valid}
        />
      </FadeInContainer>
    </Container>
  );
};

export default RegisterProductStepTwo;
